import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/*
 * Conversation types are Wundo's own, not one organisation's: these pages write
 * what every customer starts with. The Vue router put
 * `requiresSuperadminInternal` on all of them, and one layout route is where
 * that lives now — the same inner door `/admin` keeps.
 */
export const Route = createFileRoute('/_app/meeting-templates')({
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: Outlet,
});
